import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import ToolbarTextColor from './ToolbarTextColor';
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    isReducedSpacing = _ref.isReducedSpacing,
    editorView = _ref.editorView,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsScrollableElement = _ref.popupsScrollableElement,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent,
    disabled = _ref.disabled;
  var _useSharedPluginState = useSharedPluginState(api, ['textColor']),
    textColorState = _useSharedPluginState.textColorState;
  return /*#__PURE__*/React.createElement(ToolbarTextColor, {
    pluginState: textColorState,
    isReducedSpacing: isReducedSpacing,
    editorView: editorView,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
    disabled: disabled,
    pluginInjectionApi: api
  });
}